/**
 * Platform detection utilities for app download promo logging
 */

/**
 * Detects platform from user agent string
 * @param userAgent - The user agent string (defaults to window.navigator.userAgent)
 * @returns 'ios' or 'android' in lowercase
 */
export function getPlatformFromUserAgent(userAgent?: string): "ios" | "android" {
  return isIOS(userAgent) ? "ios" : "android";
}

function isIOS(userAgent?: string): boolean {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    // SSR fallback - cannot determine from user agent
    return false;
  }

  const ua = userAgent || window.navigator.userAgent;
  return /iPhone|iPad/.test(ua) || /Macintosh|MacIntel/.test(ua);
}
